import React, { useState } from 'react'
import { Camera, Film, Users, Clapperboard } from 'lucide-react'

const BehindTheScenes = () => {
  const [selectedCategory, setSelectedCategory] = useState('all')

  const categories = [
    { id: 'all', name: 'All Photos' },
    { id: 'drama', name: 'TV Drama' },
    { id: 'film', name: 'Films' },
    { id: 'music-video', name: 'Music Videos' }
  ]

  const behindScenesPhotos = [
    {
      id: 1,
      title: 'Directing Shadows of Dhaka',
      category: 'drama',
      image: 'https://images.pexels.com/photos/7991579/pexels-photo-7991579.jpeg?auto=compress&cs=tinysrgb&w=800',
      description: 'Our director working with actors on an emotional scene in old Dhaka'
    },
    {
      id: 2,
      title: 'Cinematography Setup',
      category: 'film',
      image: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=800',
      description: 'Camera crew setting up for a complex tracking shot'
    },
    {
      id: 3,
      title: 'Music Video Production',
      category: 'music-video',
      image: 'https://images.pexels.com/photos/1762578/pexels-photo-1762578.jpeg?auto=compress&cs=tinysrgb&w=800',
      description: 'Filming Monsoon Melodies with vibrant monsoon backdrop'
    },
    {
      id: 4,
      title: 'Cast Rehearsal',
      category: 'drama',
      image: 'https://images.pexels.com/photos/3062541/pexels-photo-3062541.jpeg?auto=compress&cs=tinysrgb&w=800',
      description: 'Actors rehearsing dialogue for Eternal Bonds'
    },
    {
      id: 5,
      title: 'Lighting Setup',
      category: 'film',
      image: 'https://images.pexels.com/photos/1117132/pexels-photo-1117132.jpeg?auto=compress&cs=tinysrgb&w=800',
      description: 'Technical crew preparing lighting for night scene'
    },
    {
      id: 6,
      title: 'Documentary Filming',
      category: 'film',
      image: 'https://images.pexels.com/photos/1190297/pexels-photo-1190297.jpeg?auto=compress&cs=tinysrgb&w=800',
      description: 'Capturing traditional artisans for Voices of Heritage'
    },
    {
      id: 7,
      title: 'Director and DP Collaboration',
      category: 'drama',
      image: 'https://images.pexels.com/photos/3184405/pexels-photo-3184405.jpeg?auto=compress&cs=tinysrgb&w=800',
      description: 'Director and cinematographer planning shot composition'
    },
    {
      id: 8,
      title: 'On-Set Production',
      category: 'music-video',
      image: 'https://images.pexels.com/photos/7991579/pexels-photo-7991579.jpeg?auto=compress&cs=tinysrgb&w=800',
      description: 'Full production crew during music video shoot'
    }
  ]

  const filteredPhotos = selectedCategory === 'all' 
    ? behindScenesPhotos 
    : behindScenesPhotos.filter(photo => photo.category === selectedCategory)

  const handleImageError = (e) => {
    e.target.src = 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=800'
  }

  return (
    <div className="min-h-screen bg-gray-50 py-16" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="94:4" data-component-id="client/src/pages/BehindTheScenes.jsx:94:4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="95:6" data-component-id="client/src/pages/BehindTheScenes.jsx:95:6">
        {/* Header */}
        <div className="text-center mb-12" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="97:8" data-component-id="client/src/pages/BehindTheScenes.jsx:97:8">
          <div className="flex items-center justify-center gap-3 mb-4" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="98:10" data-component-id="client/src/pages/BehindTheScenes.jsx:98:10">
            <Camera className="w-12 h-12 text-bengal-orange" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="99:12" data-component-id="client/src/pages/BehindTheScenes.jsx:99:12" />
            <h1 className="section-title text-4xl md:text-5xl text-gray-900" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="100:12" data-component-id="client/src/pages/BehindTheScenes.jsx:100:12">
              Behind-the-Scenes
            </h1>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="104:10" data-component-id="client/src/pages/BehindTheScenes.jsx:104:10">
            Explore the creative process and filmmaking journey of Shikdar Films
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="110:8" data-component-id="client/src/pages/BehindTheScenes.jsx:110:8">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
                selectedCategory === category.id
                  ? 'bg-bengal-orange text-white shadow-md'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
              data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="112:12" data-component-id="client/src/pages/BehindTheScenes.jsx:112:12"
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Photos Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="127:8" data-component-id="client/src/pages/BehindTheScenes.jsx:127:8">
          {filteredPhotos.map((photo) => (
            <div 
              key={photo.id}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group"
              data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="129:12" data-component-id="client/src/pages/BehindTheScenes.jsx:129:12"
            >
              <div className="relative h-64 overflow-hidden" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="133:14" data-component-id="client/src/pages/BehindTheScenes.jsx:133:14">
                <img 
                  src={photo.image}
                  alt={photo.title}
                  onError={handleImageError}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="134:16" data-component-id="client/src/pages/BehindTheScenes.jsx:134:16"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="141:16" data-component-id="client/src/pages/BehindTheScenes.jsx:141:16"></div>
              </div>
              <div className="p-6" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="143:14" data-component-id="client/src/pages/BehindTheScenes.jsx:143:14">
                <h3 className="text-xl font-semibold text-gray-900 mb-2 section-title" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="144:16" data-component-id="client/src/pages/BehindTheScenes.jsx:144:16">
                  {photo.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="147:16" data-component-id="client/src/pages/BehindTheScenes.jsx:147:16">
                  {photo.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Process Info Section */}
        <div className="mt-16 bg-white rounded-xl shadow-md p-8" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="156:8" data-component-id="client/src/pages/BehindTheScenes.jsx:156:8">
          <h2 className="section-title text-3xl text-gray-900 mb-8 text-center" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="157:10" data-component-id="client/src/pages/BehindTheScenes.jsx:157:10">
            Our Filmmaking Process
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="160:10" data-component-id="client/src/pages/BehindTheScenes.jsx:160:10">
            <div className="text-center" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="161:12" data-component-id="client/src/pages/BehindTheScenes.jsx:161:12">
              <div className="w-16 h-16 bg-bengal-green rounded-full flex items-center justify-center mx-auto mb-4" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="162:14" data-component-id="client/src/pages/BehindTheScenes.jsx:162:14">
                <Film className="w-8 h-8 text-white" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="163:16" data-component-id="client/src/pages/BehindTheScenes.jsx:163:16" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="165:14" data-component-id="client/src/pages/BehindTheScenes.jsx:165:14">Pre-Production</h3>
              <p className="text-sm text-gray-600" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="166:14" data-component-id="client/src/pages/BehindTheScenes.jsx:166:14">Script development, casting, and location scouting</p>
            </div>
            <div className="text-center" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="168:12" data-component-id="client/src/pages/BehindTheScenes.jsx:168:12">
              <div className="w-16 h-16 bg-bengal-orange rounded-full flex items-center justify-center mx-auto mb-4" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="169:14" data-component-id="client/src/pages/BehindTheScenes.jsx:169:14">
                <Clapperboard className="w-8 h-8 text-white" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="170:16" data-component-id="client/src/pages/BehindTheScenes.jsx:170:16" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="172:14" data-component-id="client/src/pages/BehindTheScenes.jsx:172:14">Production</h3>
              <p className="text-sm text-gray-600" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="173:14" data-component-id="client/src/pages/BehindTheScenes.jsx:173:14">Filming with professional crew and equipment</p>
            </div>
            <div className="text-center" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="175:12" data-component-id="client/src/pages/BehindTheScenes.jsx:175:12">
              <div className="w-16 h-16 bg-bengal-red rounded-full flex items-center justify-center mx-auto mb-4" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="176:14" data-component-id="client/src/pages/BehindTheScenes.jsx:176:14">
                <Camera className="w-8 h-8 text-white" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="177:16" data-component-id="client/src/pages/BehindTheScenes.jsx:177:16" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="179:14" data-component-id="client/src/pages/BehindTheScenes.jsx:179:14">Post-Production</h3>
              <p className="text-sm text-gray-600" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="180:14" data-component-id="client/src/pages/BehindTheScenes.jsx:180:14">Editing, color grading, and sound design</p>
            </div>
            <div className="text-center" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="182:12" data-component-id="client/src/pages/BehindTheScenes.jsx:182:12">
              <div className="w-16 h-16 bg-bengal-gold rounded-full flex items-center justify-center mx-auto mb-4" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="183:14" data-component-id="client/src/pages/BehindTheScenes.jsx:183:14">
                <Users className="w-8 h-8 text-white" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="184:16" data-component-id="client/src/pages/BehindTheScenes.jsx:184:16" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="186:14" data-component-id="client/src/pages/BehindTheScenes.jsx:186:14">Distribution</h3>
              <p className="text-sm text-gray-600" data-component-path="client/src/pages/BehindTheScenes.jsx" data-component-line="187:14" data-component-id="client/src/pages/BehindTheScenes.jsx:187:14">Festival submissions and audience screenings</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BehindTheScenes